export const BUDGET_TYPE_CAMPAIGN_DAILY_BUDGET = "CAMPAIGN_DAILY_BUDGET";
export const BUDGET_TYPE_CAMPAIGN_TOTAL_BUDGET_FOR_PERIOD = "CAMPAIGN_TOTAL_BUDGET_FOR_PERIOD";
export const BUDGET_TYPE_ADSETS_DAILY_BUDGET = "ADSETS_DAILY_BUDGET";
export const BUDGET_TYPE_ADSETS_TOTAL_BUDGET_FOR_PERIOD = "ADSETS_TOTAL_BUDGET_FOR_PERIOD";
export const BUDGET_TYPE_ADSETS_TOTAL_AND_DAILY_BUDGET_FOR_PERIOD = "ADSETS_TOTAL_AND_DAILY_BUDGET_FOR_PERIOD";
export const BUDGET_TYPE_CAMPAIGN_TOTAL_FOR_ADGROUPS_PERIODS = "CAMPAIGN_TOTAL_FOR_ADGROUPS_PERIODS";

export const DATA_BY_BUDGET_TYPE = {
    [BUDGET_TYPE_CAMPAIGN_DAILY_BUDGET]: {
        "title": "Presupuesto diario",
        "has_period": false,
        "has_adset_detail": false
    },
    [BUDGET_TYPE_CAMPAIGN_TOTAL_BUDGET_FOR_PERIOD]: {
        "title": "Presupuesto total para período",
        "has_period": true,
        "has_adset_detail": false
    },
    [BUDGET_TYPE_ADSETS_DAILY_BUDGET]: {
        "title": "Presupuestos diarios en Grupos de anuncios",
        "has_period": false,
        "has_adset_detail": true
    },
    [BUDGET_TYPE_ADSETS_TOTAL_BUDGET_FOR_PERIOD]: {
        "title": "Presupuestos totales en Grupos de anuncios para período",
        "has_period": true,
        "has_adset_detail": true
    },
    [BUDGET_TYPE_ADSETS_TOTAL_AND_DAILY_BUDGET_FOR_PERIOD]: {
        "title": "Presupuestos totales y diarios en Grupos de anuncios para período",
        "has_period": true,
        "has_adset_detail": true
    },
    [BUDGET_TYPE_CAMPAIGN_TOTAL_FOR_ADGROUPS_PERIODS]: {
        "title": "Presupuestos total en campañas y períodos en Grupos de anuncios",
        "has_period": true,
        "has_adset_detail": true
    },

};
